import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiCopy, FiFileText } from 'react-icons/fi';
import { LuScanText } from 'react-icons/lu';
import { getSelectedImageText, getSelectedTranscript } from '../../util/multiSelectionContent';
import CascadingSubmenu, { SubmenuButton } from './CascadingSubmenu';
import { MenuItemIcon, MenuItemLabel } from './MessageContextMenu';

export default function MessageCopyMenu({ message, onCopy }) {
    const { t } = useTranslation();
    const options = [
        { key: 'title', label: t('messages:copyTitle'), text: message?.title, Icon: FiCopy },
        { key: 'note', label: t('messages:copyNote'), text: message?.body, Icon: FiFileText },
        { key: 'transcript', label: t('messages:transcript'), text: getSelectedTranscript(message), Icon: FiFileText },
        { key: 'ocr', label: t('messages:copyImageText'), text: getSelectedImageText(message), Icon: LuScanText }
    ].filter(option => typeof option.text === 'string' && option.text.trim());
    if (!options.length) return null;

    return (
        <CascadingSubmenu label={t('common:copy')} icon={<FiCopy size={14} />}>
            {options.map(({ key, label, text, Icon }) => (
                <li key={key} role="none">
                    <SubmenuButton as="button" type="button" onClick={() => onCopy(text)}>
                        <MenuItemLabel><MenuItemIcon><Icon size={14} /></MenuItemIcon>{label}</MenuItemLabel>
                    </SubmenuButton>
                </li>
            ))}
        </CascadingSubmenu>
    );
}
